"use strict";

exports.__esModule = true;
exports["default"] = ArrowDotted;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ArrowDotted(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M5.864 15.993h5.09c.649 0 1.171-.521 1.171-1.169 0-.643-.522-1.17-1.171-1.17l-5.09.001a1.17 1.17 0 1 0 0 2.338zm-4.632 0c.649 0 1.171-.521 1.171-1.169a1.17 1.17 0 1 0-1.171 1.169zm26.696.006H15.596a1.177 1.177 0 0 1-1.178-1.175 1.18 1.18 0 0 1 1.178-1.176h12.332l-5.112-5.106a1.172 1.172 0 0 1 0-1.659 1.17 1.17 0 0 1 1.66 0l7.12 7.112c.101.107.19.234.247.382a1.117 1.117 0 0 1 0 .903c-.057.141-.146.27-.247.378l-7.158 7.151a1.159 1.159 0 0 1-1.66 0 1.173 1.173 0 0 1 0-1.66l5.15-5.15z"
  }));
}